import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form-container',
  templateUrl: './form-container.component.html',
  styleUrls: ['./form-container.component.scss']
})
export class FormContainer {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/form-container/form-container.component.ts